import { render, staticRenderFns } from "./DB_ProjectSetup.vue?vue&type=template&id=1de8cc38&scoped=true&"
import script from "./DB_ProjectSetup.vue?vue&type=script&lang=ts&"
export * from "./DB_ProjectSetup.vue?vue&type=script&lang=ts&"
import style0 from "./DB_ProjectSetup.vue?vue&type=style&index=0&id=1de8cc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de8cc38",
  null
  
)

export default component.exports